export const renderAnnoncePrice = (annonce) => {
  const { categorie, transaction, prix, frequenceLoyer, frequenceSalaire } = annonce;

  switch (categorie) {
    case "voiture":
      return <h2>Prix: {prix} FCFA</h2>;

    case "logement":
    case "terrain":
      if (transaction === "Location") {
        return (
          <h2 className="price">
            Loyer : {prix} / {typeof frequenceLoyer === "string" ? frequenceLoyer : ""}
          </h2>
        );
      } else {
        return <h2 className="price">Prix d'achat : {prix}</h2>;
      }

    case "formation":
      return typeof frequenceLoyer === "string" ? (
        <h2>
          Prix : {prix} / {frequenceLoyer}
        </h2>
      ) : (
        <h2>Prix: {prix} FCFA</h2>
      );

    case "travail":
      return typeof frequenceSalaire === "string" ? (
        <h2>
          Salaire : {prix} / {frequenceSalaire}
        </h2>
      ) : (
        <h2>Salaire: {prix} FCFA</h2>
      );

    case "rencontre":
      return null;

    default:
      return <h2>Prix: {prix} FCFA</h2>;
  }
};
